import "./App.scss";
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";
import { useEffect, useContext, Suspense,lazy, useState } from "react";
import "./i18n";
import "./App.scss";
import InitializeWallet from "helpers/InitializeWallet";
import { fetchUserAccounts } from "ts/accountInfo/tokens";
import { fetchOpenOrders } from "ts/accountInfo/openOrders";
import queryString from 'query-string';
import TradePage from "pages/TradePage";
import MarketsPage from "pages/MarketsPage";
import WalletsPage from "pages/WalletsPage";
import { ParseSerumMarkets, SERUM_MARKETS_URL } from "utils/market";
import AuthPage from "pages/AuthPage";
import toast, { Toaster } from 'react-hot-toast';
import { getBaseQuoteTokensFromMint } from "helpers/helpers";
import {ReactComponent as PrismAnimated} from "assets/icons/PRISManimated.svg";
import { TOKENLIST_URI, stored_user_pubkey } from "redux/globalState";
import { useDispatch, useSelector } from "react-redux";
import { accounts, serumMarkets, setLiquiditySources, setMarkets, setOpenOrders, setTheme, tokenList, walletConnected, walletDisconnected } from "redux/state";

export const REFRESH_INTERVAL = 40 * 1000; // 40 seconds

const App = () => {
  const state = useSelector((state) => state.storage);
  const dispatch = useDispatch();

  const { provider, wallet } = state;
  const [access, setAccess] = useState(true);
  const [fullyLoaded, setFullyLoaded] = useState(false);

  useEffect(() => {
    let providerCheck = localStorage.getItem("provider");
    if(providerCheck)
      InitializeWallet({provider:providerCheck}, dispatch);
  }, [provider]);


  useEffect(() => {
    const body = document.querySelector("body");
    let stTheme = localStorage.getItem("theme");
    if(stTheme) {
      body.dataset.theme = stTheme;
      dispatch(setTheme(stTheme));
    } else {
      localStorage.setItem("theme", state.theme);
    }
  },[])

  useEffect(() => {
    // Load Solana TokenList
    fetch(TOKENLIST_URI).then(response => response.json())
    .then(response => {
      dispatch(tokenList(response));
    })
    
  },[]);

  useEffect(() => {
    if (wallet && wallet.ready && state.tokenList) {
      wallet.connect().then((result) => {
        console.log("TRYINNA CONNECT WALLY")
        if (wallet.connected) {
          localStorage.setItem(stored_user_pubkey, wallet.publicKey.toBase58());
          dispatch(walletConnected(wallet.publicKey));
          } else
          dispatch(walletDisconnected());
      })
    }
  }, [wallet, state.tokenList]);

  // useEffect(() => {
  //   if (state.tokenList && state.publicKey) {
  //     fetchUserAccounts(state).then(result => dispatch({
  //       type: "accounts",
  //       accounts: result,
  //     }));
  //   }
  // }, [state.publicKey, state.tokenList]);

  useEffect(() => {
    if (state.tokenList && state.walletConnected && state.nextUpdate === 0) {
      // let timeout = setTimeout(() => {
        Promise.all([
          fetchUserAccounts(state),
          fetchOpenOrders(state),
        ]).then(res => {
          dispatch(accounts(res[0]));
          dispatch(setOpenOrders(res[1]));
        })
      // }, 100);
      // return () => clearTimeout(timeout);
    }
  }, [state.walletConnected, state.tokenList, state.nextUpdate]);

  useEffect(() => {
    if (state.tokenList && state.publicKey && state.newTx && state.newTx.status === "finalized") {
      let t1 = setTimeout(() => {
        fetchUserAccounts(state).then(result => dispatch(accounts(result)));
      }, 1000);
      let t2 = setTimeout(() => {
        fetchUserAccounts(state).then(result => dispatch(accounts(result)));
      }, 6000);
      let t3 = setTimeout(() => {
        fetchOpenOrders(state).then(result => dispatch(setOpenOrders(result)));
      }, 10000);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
        clearTimeout(t3);
      }
    }
  }, [state.newTx]);

  useEffect(() => {
    if(state.serumMarkets && state.tokenList) {
      let allMarkets = state.serumMarkets.all;
      let allMarketKeys = Object.keys(allMarkets).sort((a, b) =>
        allMarkets[b].quoteDepositsTotal - allMarkets[a].quoteDepositsTotal
      );
      let tokenList = state.tokenList.tokens;
      let marketsArray = [];
      
      for(let i = 0; i < allMarketKeys.length; i++) {
        let market = allMarkets[allMarketKeys[i]];
        let baseToken = market.baseMint.toBase58();
        let quoteToken = market.quoteMint.toBase58();
        let match = getBaseQuoteTokensFromMint(tokenList, baseToken, quoteToken);
        marketsArray.push({
          market: market.ownAddress.toBase58(),
          baseToken: match.baseToken,
          quoteToken: match.quoteToken
        })
      }
      dispatch(setMarkets(marketsArray));
    }
  }, [state.serumMarkets, state.tokenList])

  useEffect(() => {
    ParseSerumMarkets(state).then(response => {
      dispatch(serumMarkets(response));
    })
  },[])

  useEffect(() => {
    if(state.serumMarkets && state.tokenList) setTimeout(() => setFullyLoaded(true), 3000);
  }, [state.serumMarkets, state.tokenList]);


  return (
    <>
      {
        !fullyLoaded &&
        <div className="FORCE_FULLSCREEN">
          <PrismAnimated fill="var(--gray900)" width={190} height={55}/>
        </div>
      }
      <Router>
        <Switch>
          <Route exact path="/">
            <TradePage fullyLoaded={fullyLoaded}/>
          </Route>
          <Route exact path="/markets">
            <MarketsPage/>
          </Route>
          <Route path="/wallet/">
            <WalletsPage/>
          </Route>
        </Switch>
      </Router>
      <Toaster 
        toastOptions={{
          className: '',
          style: {
            fontSize: '16px',
          },
        }}
      />
    </>
  );
};

export default App;
